/* © Facilogi. See COPYRIGHT file for full copyright & licensing details. */

/* Gestion du thème (light / dark) via l'attribut [data-theme] sur <html>.
   Les valeurs de couleur sont des CSS custom properties définies dans
   _theme.sass (:root = light, html[data-theme="dark"] = dark). */

export type ThemeMode = "light" | "dark";

const STORAGE_KEY = "prospeneo-theme";

export function GetTheme(): ThemeMode {
    const saved = localStorage.getItem( STORAGE_KEY );

    return saved === "dark" ? "dark" : "light";
}

export function ApplyTheme( mode: ThemeMode ): void {
    document.documentElement.setAttribute( "data-theme", mode );
    localStorage.setItem( STORAGE_KEY, mode );
}

export function ToggleTheme(): ThemeMode {
    const next: ThemeMode = GetTheme() === "dark" ? "light" : "dark";

    ApplyTheme( next );

    return next;
}

/* À appeler au démarrage, avant le montage, pour éviter le flash de thème. */
export function InitTheme(): void {
    ApplyTheme( GetTheme() );
}
